import { Popover, Tooltip } from 'antd'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import AuthoriseIcon from 'components/icons/AuthoriseIcon'
import CheckCircleIcon from 'components/icons/CheckCircleIcon'
import DownLoad from 'components/icons/DownLoad'
import EyeIcon from 'components/icons/EyeIcon'
import {
  CommonFlex,
  RightSection,
  SubTitleDiv,
} from 'modules/Settings/Components/CompanyInfo/style'
import {
  AuthoFlex,
  AuthorityDiv,
  AuthSubTitleDiv,
  ComanyDiv,
  DownLoadDiv,
  FlexAuth,
  PopoverImg,
  PreviewDiv,
  TextVerified,
} from 'modules/Settings/Components/TaxInfo/style'
import { MainWrapper } from 'modules/Settings/Styles/style'
import React from 'react'
import { getFileSize } from 'utils/getFileSize'

const TaxInfo = ({ corporateData }) => {
  const handleClickFile = (url, filename) => {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = objectUrl
        a.download = filename
        document.body.appendChild(a)
        a.click()
        URL.revokeObjectURL(objectUrl)
        document.body.removeChild(a)
      })
      .catch(error => {
        console.error('Error converting Blob URL to Blob:', error)
      })
  }
  return (
    <MainWrapper>
      <ComanyDiv>Tax Information</ComanyDiv>
      <CommonFlex spaceBetween>
        <SubTitleDiv>PAN Number *</SubTitleDiv>
        <RightSection>
          <Input
            placeholder="Enter PAN number"
            width="100%"
            name="companyPAN"
            maxLength={20}
            onChange={e => { const value = e.target.value.toUpperCase() .replace(/[^A-Z0-9]/g, '')
              e.target.value = value
            }}
            rules={[
              {
                required: true,
                message: 'Please Enter PAN Number',
              },
              {
                min: 10,
                max: 10,
                pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,    
                message: 'Please Enter Valid PAN Number',
              },
            ]}
          />
        </RightSection>
      </CommonFlex>
      <CommonFlex spaceBetween>
        <SubTitleDiv>GST Number *</SubTitleDiv>
        <RightSection>
          <Input
            placeholder="Enter GST number"
            width="100%"
            name="companyGST"
            maxLength={25}
            onChange={e => { const value = e.target.value .toUpperCase() .replace(/[^A-Z0-9]/g, '')
              e.target.value = value
            }}
            rules={[
              {
                required: true,
                message: 'Please Enter GST Number',
              },
              {
                min: 15,
                max: 15,
                pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                message: 'Please Enter Valid PAN Number',
              },
            ]}
          />
        </RightSection>
      </CommonFlex>
      <CommonFlex spaceBetween>
        <SubTitleDiv>Authorized Signatory</SubTitleDiv>
        {corporateData?.authorisedSignatory ? (
          <RightSection>
            <FlexAuth spaceBetween>
              <AuthoFlex>
                <AuthoriseIcon />
                <Flex column>
                  <Tooltip title={corporateData?.authorisedSignatory?.name}>
                    <AuthorityDiv>
                      {(corporateData?.authorisedSignatory?.name?.length > 32
                        ? corporateData?.authorisedSignatory?.name.substr(
                            0,
                            32
                          ) + '...'
                        : corporateData?.authorisedSignatory?.name) || '-'}
                    </AuthorityDiv>
                  </Tooltip>
                  <AuthSubTitleDiv>
                    {corporateData?.authorisedSignatory?.type} |{' '}
                    {getFileSize(6420)}
                  </AuthSubTitleDiv>
                </Flex>
              </AuthoFlex>
              <Flex centerVertically>
                <CheckCircleIcon />
                <TextVerified>Verified</TextVerified>
                <Popover
                  getPopupContainer={() =>
                    document.getElementById(`sinatoryFile`)
                  }
                  content={
                    <PopoverImg src={corporateData?.authorisedSignatory?.url} />
                  }
                  trigger="hover"
                >
                  <PreviewDiv id={'sinatoryFile'}>
                    <EyeIcon />
                  </PreviewDiv>
                </Popover>
                <DownLoadDiv
                  onClick={() =>
                    handleClickFile(
                      corporateData?.authorisedSignatory?.url,
                      'Authorized Signatory'
                    )
                  }
                >
                  <DownLoad />
                </DownLoadDiv>
              </Flex>
            </FlexAuth>
          </RightSection>
        ) : (
          <RightSection>
            <AuthorityDiv>No File Added</AuthorityDiv>
          </RightSection>
        )}
      </CommonFlex>
    </MainWrapper>
  )
}

export default TaxInfo
